// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"f9918057","549":"8373fb9d"}[chunkId] + ".chunk.js";
};